import type { ButtonHTMLAttributes, PropsWithChildren } from "react";

export const brand = {
  navy: "#101A2D",
  cobalt: "#4058E9",
  azure: "#248DEB",
  mint: "#13C68B",
  iris: "#8057D9",
  porcelain: "#F7F9FC",
} as const;

export function NexoraMark({ size = 34 }: { size?: number }) {
  return (
    <img
      src="/brand/nexora-logo-128.png"
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      style={{ display: "block", borderRadius: Math.max(10, Math.round(size * 0.3)) }}
    />
  );
}

export function BrandLockup() {
  return (
    <span className="brand-lockup">
      <NexoraMark />
      <span><strong>NexoraVPN</strong><small>PRIVATE NETWORK</small></span>
    </span>
  );
}

export function Button({ children, className = "", ...props }: PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>>) {
  return <button className={`button ${className}`.trim()} {...props}>{children}</button>;
}
